"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformFakeQuestion = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const baseHeight = 92;
const makeClass = (height = baseHeight) => ({
    height: height,
    minHeight: height,
    backgroundColor: lib_palette_1.default.White.main,
    border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
    borderRadius: 8,
    padding: 16,
});
const makeMyClasses = calcHeight => {
    return {
        root: makeClass(baseHeight + 44),
        [FormQuestionType_1.default.CHECK]: makeClass(baseHeight + 44),
        [FormQuestionType_1.default.RATING]: makeClass(baseHeight + 58),
        [FormQuestionType_1.default.DATETIME]: makeClass(baseHeight + 75),
        [FormQuestionType_1.default.NUMBER]: makeClass(baseHeight + 71),
        [FormQuestionType_1.default.PHOTO]: makeClass(baseHeight + 68),
        [FormQuestionType_1.default.SPT]: makeClass(baseHeight + 62),
        [FormQuestionType_1.default.SIGNATURE]: makeClass(baseHeight + 276),
        [FormQuestionType_1.default.TEXT]: makeClass(baseHeight + 80),
        [FormQuestionType_1.default.LIST]: makeClass(baseHeight + calcHeight),
    };
};
function OpPerformFakeQuestion(props) {
    const { questionNode, rule } = props;
    let calcHeight = undefined;
    if (questionNode.type === FormQuestionType_1.default.LIST) {
        const noOptions = rule.options.length;
        calcHeight = Math.ceil(noOptions / 3) * 40 + 8;
    }
    const myCss = (0, web_css_1.default)(makeMyClasses, [calcHeight]);
    const className = myCss[questionNode.type] || myCss.root;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Text_1.default, { variant: "h2" }, questionNode.title),
        react_1.default.createElement(Dots_1.default, { style: { margin: '8px auto 0 auto' }, color: lib_palette_1.default.LavendarGrey })));
}
exports.OpPerformFakeQuestion = OpPerformFakeQuestion;
